import Button from '@wg/wows-react-uikit/Button'
import ButtonGroup from '@wg/wows-react-uikit/ButtonGroup'
import Currency from '@wg/wows-react-uikit/Currency'
import Dialog from '@wg/wows-react-uikit/Dialog'
import DialogBody from '@wg/wows-react-uikit/DialogBody'
import DialogFooter from '@wg/wows-react-uikit/DialogFooter'
import DialogHeader from '@wg/wows-react-uikit/DialogHeader'
import { Interpolate } from 'react-i18next'
import Message from '@wg/wows-react-uikit/Message'
import Processing from '@wg/wows-react-uikit/Processing'
import Spinner from '@wg/wows-react-uikit/Spinner'
import StepCSSTransitionGroup from '@wg/wows-react-uikit/StepCSSTransitionGroup'
import classnames from 'classnames'
import get from 'lodash/get'
import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { buyTreasuryBox, closeRegularRewardConfirmDialog, getTotalBalance, openRegularRewardConfirmDialog, TRANSACTIONS_STATUSES } from '../../../Actions/ActionTreasury'
import { t, x } from 'helpers/localization'
import RegularReward from '../RegularReward/RegularReward'
import styles from './RegularRewards.scss'
import DivTooltip from '@wg/wows-react-uikit/DivTooltip'
import TooltipBody from '@wg/wows-react-uikit/TooltipBody'

class RegularRewards extends Component {

    componentDidUpdate(prevProps, prevState) {
        const hasPendingTransactions = this.checkTransactions(this.props.transactions)
        const hasPendingTransactionsPrev = this.checkTransactions(prevProps.transactions)

        if (hasPendingTransactionsPrev && !hasPendingTransactions) {
            this.props.getTotalBalance()
        }
    }

    renderRewards = (rewards, prevIndex) => {
        const hasPendingTransactions = this.checkTransactions(this.props.transactions)

        return rewards.map((reward, index) => {
            const isAvailable = (this.props.treasury && this.props.treasury.modifiers.includes(reward.requirements.modifiers[0]))
            const haveEnoughMoney = this.props.personalResource >= reward.requirements.oil
            const needOil = reward.requirements.oil - this.props.personalResource
            return (
                <RegularReward
                    offerId={reward.offer_id}
                    members={this.props.members}
                    index={prevIndex + index + 1}
                    key={`RegularReward${reward.offer_id}`}
                    {...reward}
                    price={reward.requirements.oil}
                    isAvailable={isAvailable}
                    isPending={hasPendingTransactions}
                    haveEnoughMoney={haveEnoughMoney}
                    navigateToTreasuryBuilding={this.props.navigateToTreasuryBuilding}
                    canBuyNextLevel={this.canBuyNextLevel()}
                    needOil={needOil}
                    canDistribute={this.props.canDistribute}
                    onBuy={() => {
                        this.props.openRegularRewardConfirmDialog(reward)
                    }}
                />
            )
        })
    }

    checkTransactions = (transactions) => {
        let hasPendingTransactions = false

        if (transactions && Array.isArray(transactions)) {
            transactions.forEach(dayData => {
                if (dayData && dayData.transactions && Array.isArray(dayData.transactions)) {
                    dayData.transactions.forEach(transaction => {
                        if (transaction.status === TRANSACTIONS_STATUSES.PENDING && !hasPendingTransactions && transaction.operation === 'rewards_distribution') {
                            hasPendingTransactions = true
                        }
                        if (transaction.childTransactions && transaction.childTransactions.length) {
                            transaction.childTransactions.forEach(childTransaction => {
                                if (childTransaction.status === TRANSACTIONS_STATUSES.PENDING && !hasPendingTransactions && childTransaction.operation === 'rewards_distribution') {
                                    hasPendingTransactions = true
                                }
                            })
                        }

                    })
                }
            })
        }

        return hasPendingTransactions
    }

    canBuyNextLevel = () => {
        const nextTreasuryLevel = this.props.treasury.level + 1
        const nextLevelPrice = this.props.treasury.levels[nextTreasuryLevel] ? this.props.treasury.levels[nextTreasuryLevel].meta.cost : null
        const nextLevelAccumulativeRequirement = this.props.treasury.levels[nextTreasuryLevel] ? this.props.treasury.levels[nextTreasuryLevel].meta.accumulativeResourceRequired : null
        return nextLevelPrice && nextLevelPrice <= this.props.personalResource && nextLevelAccumulativeRequirement <= this.props.accumulativeResource
    }

    needOil = () => {
        const nextTreasuryLevel = this.props.treasury.level + 1
        const nextLevelPrice = this.props.treasury.levels[nextTreasuryLevel] ? this.props.treasury.levels[nextTreasuryLevel].meta.cost : null
        return nextLevelPrice ? nextLevelPrice - this.props.personalResource : 0
    }

    getConfirmDialogContent = () => {
        if (!this.props.rewardToConfirm) {
            return null
        }
        const interval = RegularReward.secToDays(this.props.rewardToConfirm.requirements.delay)
        const invalidReceivers = RegularReward.getNewPlayerNames(this.props.members)
        const price = this.props.rewardToConfirm.requirements.oil
        const isDisabled = invalidReceivers.length >= this.props.members.length
        const warningMessage = (
            <Message
                style="inline"
                type="error" >
                {t('Награды не начисляются игрокам, которые находятся в клане менее 14 дней')}
            </Message>
        )

        return (
            <React.Fragment>
                <div className={styles[`dialogRewardBackground-${this.props.rewardToConfirm.offer_id}`]} />
                <DialogHeader>{t('Подтверждение покупки')}</DialogHeader>
                <DialogBody>

                    <div className={styles.dialogRewardTitle}>
                        {this.props.rewardToConfirm.title}
                    </div>
                    <div className={styles.dialogRewardInterval}>
                        {!!interval ? (
                            <div className={styles.interval}>
                                <Interpolate
                                    i18nKey={x('Доступно 1 раз в %(interval)s дней')}
                                    interval={interval}
                                />
                            </div>
                        ) : (
                                <div className={styles.interval}>
                                    {t('Доступно любое количество')}
                                </div>
                            )}
                    </div>
                    <div className={styles.dialogRewardDescription}>
                        {this.props.rewardToConfirm.description}
                    </div>
                    {(invalidReceivers.length > 0) ? (
                        <React.Fragment>
                            <div className={styles.dialogRewardMessage}>
                                {warningMessage}
                            </div>
                            <div className={styles.dialogRewardWillNotReceive}>
                                <div className={styles.grey}>
                                    {t('Контейнеры не будут начислены игрокам: ')}
                                    {invalidReceivers.map((name, index) => {
                                        const isLast = index === invalidReceivers.length - 1
                                        return (
                                            <div className={styles.white} style={(index === 0) ? { marginLeft: '6px' } : {}} key={`Player-${name}`} >
                                                {`${name}`}{isLast ? null : ','}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : null}
                </DialogBody>
                <DialogFooter>
                    <div className={styles.footerPrice}>
                        <Interpolate
                            i18nKey={x('Приобрести за %(price)s?')}
                            price={(
                                <Currency
                                    amount={price}
                                    color="#fff"
                                    isBold
                                    type="oil"
                                />
                            )}
                        />
                    </div>
                    <ButtonGroup>
                        {isDisabled ? (
                            <DivTooltip tooltipBody={<TooltipBody>{warningMessage}</TooltipBody>}>
                                <Button isDisabled={true}>{t('Да')}</Button>
                            </DivTooltip>
                        ) : (
                                <Button
                                    onClick={() => {
                                        this.props.buyTreasuryBox(this.props.rewardToConfirm.offer_id)
                                        this.props.closeRegularRewardConfirmDialog()
                                    }}
                                >
                                    {t('Да')}
                                </Button>
                            )}
                        <Button
                            onClick={this.props.closeRegularRewardConfirmDialog}
                        >
                            {t('Нет')}
                        </Button>
                    </ButtonGroup>
                </DialogFooter>
            </React.Fragment>
        )
    }

    render() {

        const intervalRewards = this.props.regularRewards.availableRewardOffers.filter(item => !!item.requirements.delay)
        const extraRewards = this.props.regularRewards.availableRewardOffers.filter(item => !item.requirements.delay)
        const hasPendingTransactions = this.checkTransactions(this.props.transactions)
        const rewardRowClassname = classnames(styles.rewardsRow, {
            [styles.blur]: hasPendingTransactions
        })

        if (!this.props.isTreasuryConfigReady || !this.props.cooldownUpdated) {
            return (
                <div className={styles.wrapper}>
                    <StepCSSTransitionGroup level={1}>
                        <div className={styles.messageWrapper}>
                            <Spinner label={t('Идет загрузка данных')} />
                        </div>
                    </StepCSSTransitionGroup>
                </div>
            )
        } else if (this.props.cooldownUpdated && this.props.isTreasuryConfigReady && (!this.props.treasury || intervalRewards.length === 0 || extraRewards.length === 0)) {
            return (
                <div className={styles.wrapper}>
                    <StepCSSTransitionGroup level={1}>
                        <div className={styles.messageWrapper}>
                            <span className={styles.errorTitle}>
                                {t('Ошибка загрузки')}
                            </span>
                        </div>
                    </StepCSSTransitionGroup>
                </div>
            )
        } else {
            return (
                <div className={styles.wrapper}>
                    <div className={rewardRowClassname}>
                        {this.renderRewards(intervalRewards, 0)}
                    </div>
                    <div className={rewardRowClassname}>
                        {this.renderRewards(extraRewards, intervalRewards.length)}
                    </div>

                    {hasPendingTransactions ? (
                        <StepCSSTransitionGroup level={1}>
                            <div className={styles.overlay}>
                                <Processing
                                    isFetching
                                    isInside
                                />
                            </div>
                        </StepCSSTransitionGroup>
                    ) : null}

                    <Dialog
                        content={this.getConfirmDialogContent()}
                        size={'small'}
                        isOverlay={false}
                        isVisible={this.props.isRegularRewardConfirmDialogVisible}
                        hideDialog={this.props.closeRegularRewardConfirmDialog}
                    />
                </div>
            )
        }
    }
}

const mapStateToProps = (state: State) => {

    const clan = state.clans.items[state.currentAccount.clanId]
    const personalResource = (clan && clan.personalResource) ? clan.personalResource : 0
    const accumulativeResource = (clan && clan.accumulativeResource) ? clan.accumulativeResource : 0

    return {
        personalResource,
        accumulativeResource,
        regularRewards: state.ReducerTreasury.regularRewards,
        treasury: get(state, 'ReducerSupply.buildings.treasury', undefined),
        transactions: state.ReducerTreasury.transactions,
        isTreasuryConfigReady: state.ReducerTreasury.isTreasuryConfigReady,
        cooldownUpdated: state.ReducerTreasury.cooldownUpdated,
        members: state.members.clans[state.currentAccount.clanId] ? state.members.clans[state.currentAccount.clanId].members : [],
        isRegularRewardConfirmDialogVisible: state.ReducerTreasury.isRegularRewardConfirmDialogVisible,
        rewardToConfirm: state.ReducerTreasury.rewardToConfirm,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        buyTreasuryBox: (offerId: string) => {
            dispatch(buyTreasuryBox(offerId))
        },
        getTotalBalance: () => {
            dispatch(getTotalBalance())
        },
        openRegularRewardConfirmDialog: (reward) => {
            dispatch(openRegularRewardConfirmDialog(reward))
        },
        closeRegularRewardConfirmDialog: () => {
            dispatch(closeRegularRewardConfirmDialog())
        },
    }
}

export default translate()(connect(
    mapStateToProps,
    mapDispatchToProps
)(RegularRewards))